import api from './api';

/**
 * 토큰 사용량 관련 API 서비스
 */
class TokenUsageService {
  
  // 모든 사용자의 토큰 사용량 조회 (관리자만)
  async getAllUsersUsage(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      
      const url = `/token-usage/all-users${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('모든 사용자 토큰 사용량 조회 실패:', error);
      throw error;
    }
  }
  
  // 특정 사용자 토큰 사용량 조회 (관리자만)
  async getUserUsage(userId, params = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.limit) queryParams.append('limit', params.limit);
      
      const url = `/token-usage/users/${userId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('사용자 토큰 사용량 조회 실패:', error);
      throw error;
    }
  }
  
  // 리포트별 토큰 사용량 조회 (관리자만)
  async getReportUsage(reportId, params = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (params.limit) queryParams.append('limit', params.limit);
      
      const url = `/token-usage/reports/${reportId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('리포트별 토큰 사용량 조회 실패:', error);
      throw error;
    }
  }
}

export default new TokenUsageService();